import React, { useEffect, useState } from "react";
import {
  updateFormContentPreview,
  getFormContentPreview,
  imageUploadClientPreview,
} from "../../../../api/services/services";

import { Grid, Button, Snackbar, Box, Typography } from "@mui/material";
import PremiumPublicLayout from "../../../templates/PremiumPublicLayout";
import PremiumCard from "../../../molecules/PremiumCard";
import SectionHeader from "../../../molecules/SectionHeader";
import DescriptionIcon from "@mui/icons-material/Description";
import PersonIcon from "@mui/icons-material/Person";
import EventIcon from "@mui/icons-material/Event";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import GavelIcon from "@mui/icons-material/Gavel";
import NoteAltIcon from "@mui/icons-material/NoteAlt";
import MuiAlert from "@mui/material/Alert";
import PrintComponent from "../../PrintComponent";
import { Bucket } from "../../../../api/config/apiConfig";
import ContactDetailField from "../../../molecules/ContactDetailField";
import TextArea from "../../../atoms/Textarea";
import Input from "../../../atoms/Input";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useParams, useLocation } from "react-router-dom";
import moment from "moment";
import InvoiceDownload from "./download";

const InvoiceClientSide = () => {
  const [formContent, setFormContent] = useState({});
  const [formContentId, setFormContentId] = useState("");

  const [isEdit, setIsEdit] = useState(false);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const location = useLocation();
  const urlData = new URLSearchParams(location.search);
  const email = urlData.get("email");
  const surveyId = urlData.get("surveyId");
  const formId = urlData.get("formId");
  const token = urlData.get("token");



  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  //
  const updateContent = (data) => {
    setIsLoading(true);

    let media = [];
    if (formContent?.clientSign != "") media[0] = formContent?.clientSign;

    const body = {
      formContentId: formContentId,
      content: data ? data : formContent,
      mediaKeys: media,
      removedMediaKeys: [],
    };
    updateFormContentPreview(
      surveyId,
      formId,
      email,
      token,
      body,
      formContentId
    )
      .then((res) => {
        if (data != undefined)
          setSnackbarMessage("Signature has been added successfully!");
        else
          setSnackbarMessage(
            "Delivery Request Form has been updated successfully!"
          );

        setOpenSnackbar(true);
        getContent();
        setIsEdit(false);

        setIsLoading(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          setIsValid(false);
        }

        setIsLoading(false);
      });
  };

  const [isValid, setIsValid] = useState(false);

  //
  const getContent = () => {
    setIsLoading(true);
    getFormContentPreview(surveyId, formId, email, token)
      .then((res) => {
        setIsValid(true);
        setFormContentId(res.data.data.uuid);
        setFormContent(res.data.data.content);

        setIsLoading(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          setIsValid(false);
        }

        setIsLoading(false);
      });
  };

  useEffect(() => {
    getContent();
  }, []);


  const [surveyData, setSurveyData] = useState([]);

  return (
    <>
      {isValid ? (
        <PremiumPublicLayout
            title="Invoice"
            hideBackButton={true}
            actions={
                <div className="d-flex gap-3">
                    {!isEdit && email != formContent?.clientEmail && (
                        <Button
                            variant="contained"
                            onClick={() => {
                                setIsEdit(true);
                            }}
                            disabled={isLoading}
                             sx={{ 
                                textTransform: "none", 
                                borderRadius: "var(--radius-md)", 
                                padding: "10px 24px",
                                fontWeight: 700,
                                backgroundColor: "var(--primary-color)",
                                boxShadow: "0 4px 12px rgba(79, 70, 229, 0.2)",
                                '&:hover': { backgroundColor: 'var(--primary-hover)' }
                            }}
                            startIcon={<NoteAltIcon />}
                        >
                            Edit
                        </Button>
                    )}

                    {isEdit && email != formContent?.clientEmail && (
                         <Button
                            variant="outlined"
                             color="error"
                            onClick={() => {
                                getContent();
                                setIsEdit(false);
                            }}
                            disabled={isLoading}
                             sx={{ textTransform: "none", borderRadius: "var(--radius-md)", fontWeight: 700, padding: "10px 24px", border: "1px solid" }}
                        >
                            Cancel
                        </Button>
                    )}

                    {isEdit && email != formContent?.clientEmail && (
                         <Button
                            variant="contained"
                            onClick={() => {
                                updateContent();
                            }}
                            disabled={isLoading}
                             sx={{ 
                                textTransform: "none", 
                                borderRadius: "var(--radius-md)", 
                                padding: "10px 32px",
                                fontWeight: 700,
                                backgroundColor: "var(--primary-color)",
                                boxShadow: "0 4px 12px rgba(79, 70, 229, 0.3)",
                                '&:hover': { backgroundColor: 'var(--primary-hover)' }
                            }}
                        >
                            Save
                        </Button>
                    )}

                    {!isEdit && (
                         <Button
                            variant="contained"
                            onClick={() => {
                                if (window.innerWidth <= 768) { if (typeof setSnackbarMessage !== "undefined" && typeof setOpenSnackbar !== "undefined") { setSnackbarMessage("For a good experience, please use a desktop screen"); setOpenSnackbar(true); } else { alert("For a good experience, please use a desktop screen"); } return; }
                                const tempTitle = document.title;
                                const newTitle = `Invoice-${formContent?.clientName || 'Document'}-${moment().format("DD.MM.YYYY")}`;
                                document.title = newTitle;
                                
                                // Standardized delay for print and title restoration
                                setTimeout(() => {
                                    window.print();
                                    setTimeout(() => {
                                        document.title = tempTitle;
                                    }, 2000);
                                }, 500);
                            }}
                            disabled={isLoading}
                             sx={{ 
                                textTransform: "none", 
                                borderRadius: "var(--radius-md)", 
                                padding: "10px 24px",
                                fontWeight: 700,
                                backgroundColor: "var(--text-main)",
                                boxShadow: "0 4px 12px rgba(15, 23, 42, 0.2)",
                                '&:hover': { backgroundColor: '#000' }
                            }}
                            startIcon={<DescriptionIcon />}
                        >
                            Save as PDF
                        </Button>
                    )}
                </div>
            }
        >
             <SectionHeader title="Invoice Details" icon={<DescriptionIcon />} />
             <PremiumCard sx={{ marginBottom: "32px" }}>
                 <Grid container spacing={3}>
                     <Grid item xs={12} md={6}>
                        <ContactDetailField
                            label="Invoice No."
                            isEdit={isEdit}
                            type="text"
                            minWidth={"100%"}
                            value={formContent?.invoiceNo}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.invoiceNo = e.target.value;
                                setFormContent(values);
                            }}
                            disabled
                        />
                         <ContactDetailField
                            label="Shelozon Vendor #"
                            isEdit={isEdit}
                            type="text"
                            minWidth={"100%"}
                            value={formContent?.vendorNo}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.vendorNo = e.target.value;
                                setFormContent(values);
                            }}
                        />
                         <ContactDetailField
                            label="Date"
                            isEdit={isEdit}
                            type="date"
                            minWidth={"100%"}
                            value={formContent?.date}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.date = e.target.value;
                                setFormContent(values);
                            }}
                        />
                     </Grid>
                     <Grid item xs={12} md={6}>
                         <Box sx={{ mb: 3 }}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>To:</Typography>
                             {isEdit ? (
                                <TextArea
                                    label="To"
                                    value={formContent?.to}
                                    onChange={(e) => {
                                        let values = { ...formContent };
                                        values.to = e.target.value;
                                        setFormContent(values);
                                    }}
                                    rows={3}
                                />
                             ) : (
                                <Typography variant="body1">{formContent?.to || "-"}</Typography>
                             )}
                         </Box>
                         <Box sx={{ mb: 3 }}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>For:</Typography>
                             {isEdit ? (
                                <TextArea
                                    label="For"
                                    value={formContent?.for}
                                    onChange={(e) => {
                                        let values = { ...formContent };
                                        values.for = e.target.value;
                                        setFormContent(values);
                                    }}
                                    rows={3}
                                />
                             ) : (
                                <Typography variant="body1">{formContent?.for || "-"}</Typography>
                             )}
                         </Box>
                     </Grid>
                 </Grid>
             </PremiumCard>

             <SectionHeader title="Items" icon={<MonetizationOnIcon />} />
             <PremiumCard sx={{ marginBottom: "32px", overflow: "hidden" }}>
                <TableContainer component={Paper} elevation={0} sx={{ border: "1px solid #eee" }}>
                    <Table>
                        <TableHead sx={{ backgroundColor: "#f8f9fa" }}>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 600 }}>Item No</TableCell>
                                <TableCell sx={{ fontWeight: 600 }}>Description</TableCell>
                                <TableCell sx={{ fontWeight: 600, width: '15%' }}>Quantity</TableCell>
                                <TableCell sx={{ fontWeight: 600, width: '20%' }}>Amount</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {formContent?.dataRows?.length > 0 ? (
                                formContent.dataRows.map((row, index) => (
                                    <TableRow key={index} hover>
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>
                                            {isEdit ? (
                                                <TextArea
                                                    value={row?.description}
                                                    onChange={(e) => {
                                                        const values = { ...formContent };
                                                        const valuesRows = [...formContent?.dataRows];
                                                        valuesRows[index].description = e.target.value;
                                                        setFormContent(values);
                                                    }}
                                                    rows={2}
                                                />
                                            ) : (
                                                row?.description || "-"
                                            )}
                                        </TableCell>
                                        <TableCell>
                                            {isEdit ? (
                                                <Input
                                                    type="number"
                                                    value={row?.quantity}
                                                    onChange={(e) => {
                                                        const values = { ...formContent };
                                                        const valuesRows = [...formContent?.dataRows];
                                                        valuesRows[index].quantity = e.target.value;
                                                        setFormContent(values);
                                                    }}
                                                />
                                            ) : (
                                                row?.quantity || "-"
                                            )}
                                        </TableCell>
                                        <TableCell>
                                            {isEdit ? (
                                                <Input
                                                    type="text"
                                                    value={row?.amount}
                                                    onChange={(e) => {
                                                        const values = { ...formContent };
                                                        const valuesRows = [...formContent?.dataRows];
                                                        valuesRows[index].amount = e.target.value;
                                                        setFormContent(values);
                                                    }}
                                                />
                                            ) : (
                                                row?.amount || "-"
                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={4} align="center">
                                        <div className="py-4">No Records to Show</div>
                                    </TableCell>
                                </TableRow>
                            )}
                            {/* Totals Row */}
                            {formContent?.dataRows?.length > 0 && (
                                <TableRow sx={{ backgroundColor: "#f0f7ff" }}>
                                    <TableCell colSpan={2} sx={{ fontWeight: 600, textAlign: 'right' }}>
                                        Grand Total (Words):
                                    </TableCell>
                                    <TableCell colSpan={2}>
                                         <b>
                                            {isEdit ? (
                                                <Input
                                                    value={formContent?.totalAmountinEnglish}
                                                    onChange={(e) => {
                                                        const values = { ...formContent };
                                                        values.totalAmountinEnglish = e.target.value;
                                                        setFormContent(values);
                                                    }}
                                                />
                                            ) : (
                                                formContent?.totalAmountinEnglish || "-"
                                            )}
                                        </b>
                                    </TableCell>
                                </TableRow>
                            )}
                            {formContent?.dataRows?.length > 0 && (
                                <TableRow sx={{ backgroundColor: "#e3f2fd" }}>
                                    <TableCell colSpan={2} sx={{ fontWeight: 600, textAlign: 'right', fontSize: '1.1rem' }}>
                                        Total Amount:
                                    </TableCell>
                                    <TableCell colSpan={2} sx={{ fontWeight: 600, fontSize: '1.1rem', color: '#1976d2' }}>
                                        {isEdit ? (
                                            <Input
                                                value={formContent?.totalAmount}
                                                onChange={(e) => {
                                                    const values = { ...formContent };
                                                    values.totalAmount = e.target.value;
                                                    setFormContent(values);
                                                }}
                                            />
                                        ) : (
                                            formContent?.totalAmount || "-"
                                        )}
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
             </PremiumCard>

             <SectionHeader title="Bank Details" icon={<AccountBalanceIcon />} />
             <PremiumCard sx={{ marginBottom: "32px" }}>
                 <Grid container spacing={3}>
                     <Grid item xs={12} md={6}>
                        <ContactDetailField
                            label="Account Title"
                            isEdit={isEdit}
                            type="text"
                            minWidth={"100%"}
                            value={formContent?.bankDetails?.title}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.bankDetails.title = e.target.value;
                                setFormContent(values);
                            }}
                        />
                         <ContactDetailField
                            label="IBAN No"
                            isEdit={isEdit}
                            type="text"
                            minWidth={"100%"}
                            value={formContent?.bankDetails?.iban}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.bankDetails.iban = e.target.value;
                                setFormContent(values);
                            }}
                        />
                     </Grid>
                     <Grid item xs={12} md={6}>
                         <ContactDetailField
                            label="Swift Code"
                            isEdit={isEdit}
                            type="text"
                            minWidth={"100%"}
                            value={formContent?.bankDetails?.swiftCode}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.bankDetails.swiftCode = e.target.value;
                                setFormContent(values);
                            }}
                        />
                         <ContactDetailField
                            label="Branch Name & Code"
                            isEdit={isEdit}
                            type="text"
                            minWidth={"100%"}
                            value={formContent?.bankDetails?.branchNameCode}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.bankDetails.branchNameCode = e.target.value;
                                setFormContent(values);
                            }}
                        />
                     </Grid>
                 </Grid>
             </PremiumCard>

             <SectionHeader title="Terms & Conditions" icon={<GavelIcon />} />
             <PremiumCard sx={{ marginBottom: "32px" }}>
                 <Grid container spacing={3}>
                     <Grid item xs={12} sx={{ mb: 3 }}>
                        <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>Terms & Conditions</Typography>
                             {!isEdit ? (
                                <Typography variant="body1">{formContent?.termsAndConditions || "-"}</Typography>
                             ) : (
                                <TextArea
                                    rows="3"
                                    value={formContent?.termsAndConditions}
                                    onChange={(e) => {
                                        let values = { ...formContent };
                                        values.termsAndConditions = e.target.value;
                                        setFormContent(values);
                                    }}
                                />
                             )}
                     </Grid>
                     <Grid item xs={12}>
                        <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>Validity</Typography>
                             {!isEdit ? (
                                <Typography variant="body1">{formContent?.validity || "-"}</Typography>
                             ) : (
                                <TextArea
                                    rows="3"
                                    value={formContent?.validity}
                                    onChange={(e) => {
                                        let values = { ...formContent };
                                        values.validity = e.target.value;
                                        setFormContent(values);
                                    }}
                                />
                             )}
                     </Grid>
                 </Grid>
             </PremiumCard>

             <SectionHeader title="Signatures" icon={<DescriptionIcon />} />
             <PremiumCard>
                <Grid container spacing={4} justifyContent="flex-end">
                    <Grid item xs={12} sm={6} md={4} className="text-right d-flex flex-column align-items-end">
                        <div
                            style={{ height: "90px", width: "100%" }}
                            className="d-flex justify-content-center align-items-end"
                        >
                            {formContent?.adminSign?.trim()?.length > 0 && (
                                <img
                                    alt=""
                                    src={`${Bucket}${formContent.adminSign}`}
                                    height={80}
                                    width={200}
                                    style={{maxHeight: '80px', maxWidth: '100%', objectFit: 'contain'}}
                                />
                            )}
                        </div>
                        <div style={{ borderTop: "1px solid #000", marginTop: "10px", width: "100%" }}></div>
                        <p className="my-1 text-center" style={{ width: '100%' }}>
                            <b>{"Shelozon Movers Packers & Logistics Pvt Ltd"}</b>
                        </p>
                    </Grid>
                </Grid>
             </PremiumCard>
        </PremiumPublicLayout>
      ) : (
        <div className="no-print">
          {isLoading ? (
            <div> Loading...</div>
          ) : (
            <div> Ooops... Something went wrong...</div>
          )}
        </div>
      )}

      <PrintComponent>
        <InvoiceDownload surveyData={surveyData} formContent={formContent} />
      </PrintComponent>

      {/* snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000} // Adjust the duration as needed
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          severity={
            snackbarMessage?.includes("successful") ? "success" : "error"
          }
          onClose={handleCloseSnackbar}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
      {/* /snackbar */}
    </>
  );
};

export default InvoiceClientSide;
